import { FC, Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Dialog, Link, Stack, Typography } from '@mui/material';

import { Icon, ListSubheader, Menu } from '@components/base';
import { SubscriberLoginForm } from '@components/layout';
import useSubscriber from '@hooks/useSubscriber';

type ViewAsProps = {
  setViewAsSubscriber: (viewAsSubscriber: boolean) => void;
  viewAsSubscriber: boolean;
};

const ViewAs: FC<ViewAsProps> = ({ setViewAsSubscriber, viewAsSubscriber }) => {
  const { t } = useTranslation();
  const { handleLogout, isAuthenticating, subscriber } = useSubscriber();

  const [loginDialogOpen, setLoginDialogOpen] = useState(false);

  return (
    <Fragment>
      <Menu>
        <Menu.ChipButton
          avatar={viewAsSubscriber ? <Icon name='subscriber' /> : undefined}
          label={viewAsSubscriber && subscriber ? subscriber.name : t('viewAs')}
          size='small'
          variant='outlined'
        />

        <Menu.Content>
          <ListSubheader>{t('viewAs')}</ListSubheader>

          <Menu.Item
            icon={<Icon name='admin' />}
            onClick={() => setViewAsSubscriber(false)}
            selected={!viewAsSubscriber}
          >
            {t('admin')}
          </Menu.Item>

          {subscriber ? (
            <Menu.Item
              icon={<Icon name='subscriber' />}
              onClick={() => setViewAsSubscriber(true)}
              rightContent={
                <Box ml={4}>
                  <Link
                    component='button'
                    onClick={e => {
                      e.stopPropagation();
                      handleLogout();
                      if (viewAsSubscriber) setViewAsSubscriber(false);
                    }}
                  >
                    Log out
                  </Link>
                </Box>
              }
              selected={viewAsSubscriber}
            >
              {subscriber?.name}
            </Menu.Item>
          ) : (
            <Stack alignItems='center' p={2} spacing={1} width={240}>
              <Typography align='center' color='text.secondary' fontStyle='' variant='body2'>
                <em>
                  <Link component='button' onClick={() => setLoginDialogOpen(true)}>
                    {t('logIn')}
                  </Link>{' '}
                  {t('viewAs.login.2')}
                </em>
              </Typography>
            </Stack>
          )}
        </Menu.Content>
      </Menu>

      {loginDialogOpen && (
        <Dialog onClose={isAuthenticating ? undefined : () => setLoginDialogOpen(false)} open>
          <SubscriberLoginForm
            callbackFn={() => {
              setLoginDialogOpen(false);
              setViewAsSubscriber(true);
            }}
          />
        </Dialog>
      )}
    </Fragment>
  );
};

export default ViewAs;
